import type {
  GetSignedRecordingUrlInput,
  GetSignedRecordingUrlOutput,
} from '@infra/controllers/get-signed-recording-url.controller';
import { Logger } from '@main/utils/logger';
import type { BaseUsecase } from '@usecases/base-usecase';

export type GetSignedRecordingUrlRequest = GetSignedRecordingUrlInput;
export type GetSignedRecordingUrlResponse = GetSignedRecordingUrlOutput;

export interface IntegrationManagerClient {
  getrecordingUrlByCallId(recordingUrl: string): Promise<string>;
}

export interface GetSignedRecordingUrlUsecase
  extends BaseUsecase<
    GetSignedRecordingUrlRequest,
    GetSignedRecordingUrlResponse
  > {
  run(
    req: GetSignedRecordingUrlRequest,
  ): Promise<GetSignedRecordingUrlResponse>;
}

export class GetSignedRecordingUrl implements GetSignedRecordingUrlUsecase {
  private logger: Logger;
  constructor(private integrationSettingsClient: IntegrationManagerClient) {
    this.logger = new Logger();
  }

  async run({
    recordingUrl,
  }: GetSignedRecordingUrlRequest): Promise<GetSignedRecordingUrlResponse> {
    const url = new URL(recordingUrl);
    const getRecodingPathandQuery = url.pathname + url.search;

    if (getRecodingPathandQuery) {
      const signedRecordingUrl =
        await this.integrationSettingsClient.getrecordingUrlByCallId(
          getRecodingPathandQuery,
        );
      return {
        url: signedRecordingUrl,
      };
    }
    this.logger.info('integrationId not found in recording Url', {
      action: 'GetSignedRecordingUrlUsecase',
      recordingUrl,
    });
    return {
      url: '',
    };
  }
}
